import { lazy } from "react";

export { REPORTS_MAIN_PATH } from "./main-path";
export const ReportsMain = lazy(() => import("./main"));
